import { styled } from '@obvio/app'

/**
 * `<h1>` kept in the DOM for crawlers and screen readers on pages whose design
 * shows the title only as part of an image or a decorative heading.
 */
export const HiddenHeading = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
`
